import React ,{Fragment }from 'react';
import CandidateReview from '../../../Client/CandidateReview/CandidateReview';
import Checkbox from '../../Checkbox/Checkbox';
import './SelectCandidatesStep1.css';
import ConsoleLog from '../../../../hoc/ConsoleLog/ConsoleLog';

const SelectCandidatesStep1 = (props) => {
  return(
    <Fragment>
      {props.showStep1Content?
        <Fragment>
          <div className="select-all">
            <Checkbox className="select-all-checkbox" id="selectAllCheck" onChange={(e) => props.handleCheckbox(e)} checked={props.selectAllChecked}/>
            <label for="selectAllCheck" className="select-all-label">Select All</label>
          </div>
          <div className="select-candidates">
            {props.pool?props.pool.map((data) => {          
            return <CandidateReview {...data} footerRemove={true} handleCandidateSelect={props.handleCandidateSelect} selectedCandidates={props.selectedCandidates}/>
            }):null}
          </div>
        </Fragment>
     :null}
    </Fragment>


  );
}

export default SelectCandidatesStep1;


// WEBPACK FOOTER //
// ./src/components/UI/StepperContent/SelectCandidatesStep1/SelectCandidatesStep1.js